import { render, staticRenderFns } from "./iform.vue?vue&type=template&id=06615ab4"
import script from "./iform.vue?vue&type=script&lang=js"
export * from "./iform.vue?vue&type=script&lang=js"
import style0 from "./iform.vue?vue&type=style&index=0&id=06615ab4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports